import request from './service/index';  
// exploration 列表查询
export function getExplorationList_Api(data){//查询列表
    return request({
        url:'CMS/exploration/exploration_list',
        method:'post',
        data:data
    });
}

// exploration 数量
export function getExplorationCount_Api(){
    return request({
        url:'CMS/exploration/exploration_count',
        method:'get'
    })
}

// exploration 地理位置
export function getScholarDropDown_Api(){
    return request({
        url:'CMS/tools/scholar_drop_down',
        method:'get'
    })
}

export function getBpDropDown_Api(){//批量删除
    return request({
        url:'CMS/tools/bp_drop_down',
        method:'get',
    })
}

export function getExplorationContent_Api(id,type){//查询
    return request({
        url:`CMS/exploration/exploration_content?exploration_id=${id}&content_type=${type}`,
        method:'get'
    })
}

export function createExplorationContent_Api(data){
    return request({
        url:`CMS/exploration/exploration_content`,
        method:'post',
        data:data
    });
}

export function deleteExplorationContent_Api(data){
    return request({
        url:`CMS/exploration/exploration_content`,
        method:'delete',
        data:data
    });
}

export function updateExplorationContent_Api(data){
    return request({
        url:`CMS/exploration/exploration_content`,
        method:'put',
        data:data
    })
}

export function getExplorationDetail_Api(id){//查询
    return request({
        url:`CMS/exploration/exploration_detail?exploration_id=${id}`,
        method:'get'
    })
}

export function createExplorationDetail_Api(data){
    return request({
        url:`CMS/exploration/exploration_detail`,
        method:'post',
        data:data
    });
}

export function deleteExplorationDetail_Api(data){
    return request({
        url:`CMS/exploration/exploration_detail`,
        method:'delete',
        data:data
    });
}

export function updateExplorationDetail_Api(data){
    return request({
        url:`CMS/exploration/exploration_detail`,
        method:'put',
        data:data
    })
}

export function outputExploration_Api(data){
    return request({
        url:'CMS/exploration/output',
        method:'post',
        data:data,
        responseType: 'arraybuffer',
    })
}




// WEBPACK FOOTER //
// ./src/apis/exploration.api.js